module.exports = __webpack_public_path__ + "img/Jump Casting78.13d801ec.jpg";